import "../SalesReport.css";
import Logo from "../../../assets/images/logo.png";
import { useSelector } from "react-redux";
import { ReadCookie } from "../../../utils/readCookie";
import { useDispatch } from "react-redux";
import moment from "moment";
import numeral from "numeral";

const dateFormatList = ["MM-DD-YYYY"];
const CreditMemoReportHeader = () => {
  const token = ReadCookie("token");
  const menuId = ReadCookie("menuId");
  const dispatch = useDispatch()
  const { salesReportOrderPrint, creditMemoReportPrint } = useSelector((state) => state);




  const headerData = creditMemoReportPrint && creditMemoReportPrint?.payload?.data[0];




  let sumAmount = creditMemoReportPrint?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(
      currentValue.amount
    ));
  },
    0);



  return (
    <div className='sales-report'>

      <div className="credit-report-header">
        {/* header Left */}
        <div className="header-left-side ">
          {/* Logo & Text */}
          <div className="sales-report-Logo-Container">
            <div>
              <img width={250} height={72} src={Logo} />
            </div>
            {/* Logo Items */}
            <div className="sales-report-Logo_items">
              <div>Tone Deaf World LLC.</div>
              <div>121 Varick Street,4th Floor</div>
              <div>NEW YORK ,NY 10013, USA</div>
              <div>TEL : (646) 514-9736</div>
              <div>FAX : (212) 991-9989</div>
              <div>DUNS # : 827403291</div>
            </div>
            {/* Logo Items */}
          </div>
          {/* Items details */}
          <div>
            <div className="items-detail-container">
              {/* Sold To */}
              <div className="sold-to-Container">
                <div className="">
                  <div className="font_weight">Customer Billing</div>
                  <br />
                  {/* <div className="sold-to-data">{headerData && headerData.customer_name}</div> */}
                </div>
                <div

                >
                  {/* <div className="font_weight"></div> */}
                  <div className="sold-to-data">{headerData && headerData.customer_name}</div>
                  <div className="sold-to-data">{headerData && headerData.address_1}</div>
                  <div className="sold-to-data">{headerData && headerData.address_2}</div>
                  <div className="sold-to-data">{headerData && headerData.city_name + " " + headerData.state_name + " " + headerData.zip_code}</div>
                  <div className="sold-to-data">{headerData && headerData.country_name}</div>
                </div>
              </div>
              <div className="sold-to-Container">
                <div className="">
                  <div className="font_weight">Customer Shipping</div>
                  <br />
                  {/* <div className="sold-to-data">{headerData && headerData.customer_name}</div> */}
                </div>
                <div

                >
                  {/* <div className="font_weight"></div> */}
                  <div className="sold-to-data">{headerData && headerData.ship_customer_name}</div>
                  <div className="sold-to-data">{headerData && headerData.ship_address_1}</div>
                  <div className="sold-to-data">{headerData && headerData.ship_address_2}</div>
                  <div className="sold-to-data">{headerData && headerData.ship_city_name + " " + headerData.ship_state_name + " " + headerData.ship_zip_code}</div>
                  <div className="sold-to-data">{headerData && headerData.ship_country_name}</div>
                </div>
              </div>

            </div>
          </div>
          {headerData && headerData.memo && (
            <div style={{ marginTop: 15, width: 600 }}>
              <span><span className="font_weight">Memo</span> : {headerData && headerData.memo}</span>
            </div>
          )}

        </div>

        {/* header Left */}
        {/* header Right */}

        <div className="header-right-side2" style={{ height: "80px" }}>
          <div className="header-right-side3">
            <div className="sales-order-heading">Credit Memo#{headerData && headerData.note_header_no}</div>
            <div className="sales-order-heading">RA#{headerData && headerData.ra_no}</div>
            <div className="sales-order-heading">Invoice#{headerData && headerData.invoice_header_no}</div>
            <div className="sales-order-items-container">
              <div className="sales-order-items-left">


                {/* <div className="font_weight">CN No :</div>
              <div className="font_weight">Date :</div> */}
                {/* <div className="font_weight">Total :</div> */}
                <div className="sales_order_content">
                  {/* <div>{headerData && headerData.note_header_no}</div> */}
                  <br />
                  <div>Date:{headerData && moment(headerData.note_date).format("MM/DD/YYYY")}</div>
                  {/* <div>${sumAmount}</div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="header-right-total" style={{ marginTop: "10px" }}>
            <div className="sales-order-items-container2">
              <div className="sales-order-items-left">
                <div className="sales-order-heading">TOTAL</div>
              </div>
              <div className="sales_order_content2">
                <div>${numeral(sumAmount - headerData.re_stock - headerData.return_label_fee).format("00.00")}</div>
              </div>
            </div>
          </div>

        </div>
        {/* header Right */}
      </div>
    </div>
  );
};

export default CreditMemoReportHeader;
